import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import PropTypes from "prop-types";
import { ButtonGroup as CoreButtonGroup } from "@vds-core/buttons";
import Button from "./Button";
var propTypes = {
  /**
   * If provided, Button components will be rendered based on this data.
   * @typeName buttonData
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.oneOf(["small", "large"]),
    buttonType: PropTypes.oneOf(["primary", "secondary", "textLink", "textLinkCaret"]),
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    surface: PropTypes.oneOf(["light", "dark"]),
    href: PropTypes.string,
    ariaLabel: PropTypes.string
  })),

  /**
   * Component will render in Inverted state.
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  inverted: false
};

var ButtonGroup = function ButtonGroup(props) {
  function _onClick(e, onClick) {
    if (e.detail !== 0) {
      onClick && onClick(e);
      e.target.blur();
    } else if (e.type === "click") {
      onClick && onClick(e);
    }
  } // NOTE props is returned from core


  function _renderButton(props) {
    var buttonType = props.buttonType,
        children = props.children,
        size = props.size,
        width = props.width,
        _onClick2 = props.onClick,
        ariaLabel = props.ariaLabel,
        surface = props.surface;

    if (buttonType === "primary") {
      return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        primary: true,
        inverted: surface === "dark",
        style: {
          maxWidth: "100%"
        },
        ariaLabel: ariaLabel,
        children: children,
        size: size,
        width: size !== "small" && "100%",
        onClick: function onClick(e) {
          return _onClick(e, _onClick2);
        }
      }));
    } else if (buttonType === "secondary") {
      return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        inverted: surface === "dark",
        secondary: true,
        style: {
          maxWidth: "100%"
        },
        ariaLabel: ariaLabel,
        children: children,
        size: size,
        width: size !== "small" && "100%",
        onClick: function onClick(e) {
          return _onClick(e, _onClick2);
        }
      }));
    }
  }

  var _calculateButtonSpacing = function _calculateButtonSpacing(size, buttonType) {
    var rightSpacing;
    var bottomSpacing;
    var isButton = buttonType === "primary" || buttonType === "secondary";

    switch (size) {
      case "large":
        rightSpacing = isButton ? "3X" : "6X";
        bottomSpacing = isButton ? "3X" : "4X";
        break;

      case "small":
        rightSpacing = isButton ? "2X" : "4X";
        bottomSpacing = isButton ? "4X" : "4X";
        break;
    }

    return {
      rightSpacing: rightSpacing,
      bottomSpacing: bottomSpacing
    };
  };

  var _getButtonWrapperWidth = function _getButtonWrapperWidth(size, width) {
    if (size === "small") {
      return "auto";
    } else return width;
  };

  var _calculateRowSpacing = function _calculateRowSpacing(rowData, nextRowData) {
    var size = rowData.length > 0 && rowData[0].size;
    return size === "small" ? "4X" : "3X";
  };

  return /*#__PURE__*/React.createElement(CoreButtonGroup, _extends({}, props, {
    surface: props.inverted ? "dark" : "light",
    renderButton: _renderButton,
    maxWidth: "596px",
    calculateButtonSpacing: _calculateButtonSpacing,
    getButtonWrapperWidth: _getButtonWrapperWidth,
    calculateRowSpacing: _calculateRowSpacing
  }));
};

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
export default ButtonGroup;